"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSlugChunkTiming = exports.isMarkedUntimed = void 0;
const timingStringParsers_1 = require("../timing/timingStringParsers");
const isMarkedUntimed = (node) => !!node.attrs.untimed;
exports.isMarkedUntimed = isMarkedUntimed;
const getSlugChunkTiming = ({ chunk, readRate, includeUntimed, }) => {
    let bracketSeconds = 0;
    let currentDialogueLength = 0;
    chunk.contents.forEach((block) => {
        const exclude = (0, exports.isMarkedUntimed)(block.pmNode) && !includeUntimed;
        if (exclude) {
            return;
        }
        if (block.elementType === 'dialogue') {
            const timeableText = block.pmNode.textContent.replace(/\s/g, '');
            currentDialogueLength += timeableText.length;
        }
        else if (block.elementType === 'bracket') {
            const { seconds } = (0, timingStringParsers_1.getBracketTimingInfo)(block.pmNode);
            bracketSeconds += seconds;
        }
    });
    const dialogueSeconds = Math.round(currentDialogueLength / readRate);
    return {
        bracketSeconds,
        dialogueSeconds,
        totalSeconds: bracketSeconds + dialogueSeconds,
    };
};
exports.getSlugChunkTiming = getSlugChunkTiming;
